import PropTypes from "prop-types"
import { Person } from "@mui/icons-material"
import { connect } from "react-redux"
import { get } from "lodash"
import Header from "modules/home-header"

function TeamMembersHeader({ account, name }) {
  const teamName = name ? `Team Members: ${name} ` : "Team Members"
  return <Header Icon={Person} title={teamName} account={account} />
}

TeamMembersHeader.propTypes = {
  account: PropTypes.string.isRequired,
  name: PropTypes.string,
}

export default connect(state => ({ name: get(state, "global.data.teamMembers.data.team.name") }), null)(TeamMembersHeader)
